import useApi from './useApi';

const useCampService = () => {
  const { api } = useApi();

  // Camp managment

  const getAllCamps = () => api({
    method: 'get',
    url: '/product-marketing/v1/establishments/own/camps',
  });

  const getCamp = (campId) => api({
    method: 'get',
    url: `/product-marketing/v1/establishments/own/camps/${campId}`,
  });

  const postCamp = (camp) => api({
    method: 'post',
    url: '/product-marketing/v1/establishments/own/camps',
    data: camp,
  });

  const putCamp = ({ campId, camp }) => api({
    method: 'put',
    url: `/product-marketing/v1/establishments/own/camps/${campId}`,
    data: camp,
  });

  const putCampTranslations = ({ campId, langCode, translations }) => api({
    method: 'put',
    url: `/product-marketing/v1/establishments/own/camps/${campId}/translations/${langCode}`,
    data: translations,
  });

  // Static data

  const getCampTypes = () => api({
    method: 'get',
    url: '/product-marketing/v1/camp-types',
  });

  const getCampSports = () => api({
    method: 'get',
    url: '/product-marketing/v1/camp-sports',
  });

  const getCampFormats = () => api({
    method: 'get',
    url: '/product-marketing/v1/camp-formats',
  });

  const getCampStartDays = () => api({
    method: 'get',
    url: '/product-marketing/v1/camp-start-days',
  });

  const getCampFeatures = () => api({
    method: 'get',
    url: '/product-marketing/v1/camp-features',
  });

  const getCampTags = () => api({
    method: 'get',
    url: '/product-marketing/v1/camp-tags',
  });

  return {
    getAllCamps,
    getCamp,
    postCamp,
    putCamp,
    putCampTranslations,
    getCampTypes,
    getCampSports,
    getCampFormats,
    getCampStartDays,
    getCampFeatures,
    getCampTags,
  };
};

export default useCampService;
